import { Button, ReceiptsTable, StatusMessage, type ReceiptsTableRow } from '@krp/ui-kit'
import type { AnalyticsPage, AnalyticsReceipt } from '../../cashier-analytics/model/types'
import { receiptColor } from '../../cashier-analytics/model/analytics'
import { problemText, type SalesPointProblem } from '../model/format'

export interface ShopDayReceiptsProps {
  timeZoneId: string
  page: AnalyticsPage | undefined
  busy: boolean
  error: SalesPointProblem | null
  more: () => void
  /** Открывает чек в окне его источника поверх статистики по адресу, который отдала служба. */
  open: (originalPath: string) => void
  /** Отказ открыть чек: источник не зарегистрировал окно чека. */
  openError: string | null
}

interface ShopReceiptRow extends ReceiptsTableRow { item: AnalyticsReceipt }

const timeOf = (at: string | null, timeZoneId: string) =>
  at === null ? 'не указано' : new Date(at).toLocaleTimeString('ru-RU', { timeZone: timeZoneId, hour: '2-digit', minute: '2-digit' })

const rowOf = (item: AnalyticsReceipt, timeZoneId: string): ShopReceiptRow => ({
  id: `${item.resourceId}:${item.receipt.key}`, item, refund: item.receipt.isRefund, number: item.receipt.number,
  at: timeOf(item.receipt.at, timeZoneId), register: item.receipt.registerName, cashier: item.receipt.cashierName,
  total: item.receipt.amount, cash: item.receipt.cashAmount, card: item.receipt.cardAmount,
})

/** Чеки магазина за один день — общей таблицей чеков; нажатие открывает окно чека источника, в списке чек не раскрывается. */
export function ShopDayReceipts(props: ShopDayReceiptsProps) {
  const rows = (props.page?.items ?? []).map((item) => rowOf(item, props.timeZoneId))
  return <section className="sales-points__receipts" aria-label="Чеки за день" aria-busy={props.busy}>
    <h3>Чеки за день{props.page === undefined ? '' : `: ${props.page.total}`}</h3>
    {props.error !== null && <StatusMessage kind="error" title="Не удалось получить чеки" text={problemText(props.error)} />}
    {props.openError !== null && <StatusMessage kind="error" title="Не удалось открыть чек" text={props.openError} />}
    {props.busy && rows.length === 0 && <p role="status">Загружаем чеки…</p>}
    {props.page?.total === 0 && <p>За этот день чеков нет.</p>}
    {rows.length > 0 && <ReceiptsTable label="Чеки магазина за день" rows={rows} onOpen={(row) => props.open(row.item.receipt.originalPath)}
      columns={[{ id: 'source', label: 'Источник', title: (row) => row.item.resourceName,
        cell: (row) => <span className="krp-receipt-table__source"><i style={{ backgroundColor: receiptColor(row.item.resourceId, row.item.receipt.registerKey) }} aria-hidden="true" />{row.item.resourceName}</span> }]} />}
    {props.page?.nextOffset != null && <Button actionId="receipts.sales-points.more" busy={props.busy} onClick={props.more}>Показать ещё</Button>}
  </section>
}
